export default "__VITE_ASSET__C26ZvXmh__"